export default __webpack_public_path__ + "static/media/KFOlCnqEu92Fr1MmWUlfChc4AMP6lbBP.e4878a76.woff2";